import http from '@/libs/http'
import { reject } from 'lodash'

export function ListStock (queryData) {
  return new Promise((resolve, reject) => {
    http.get('crm/erp/geterpstockinfo', { params: queryData }).then((resp) => {
      const partQueryInfos = resp.items.map(t => {
        return {
          brandCode: t.brandCode,
          partCode: t.partCode,
          marketCode: t.brandCode === 'vw' ? 'CN' : ''
        }
      })
      QueryPartCost4s(partQueryInfos).then((priceInfos) => {
        resp.items.forEach(stock => {
          const priceInfo = priceInfos.find(t => t.brandCode === stock.brandCode && t.partCode === stock.partCode)
          stock.cost4s = (priceInfo && priceInfo.cost) || stock.cost4s
        })
        resolve(resp)
      }).catch(e => {
        resolve(resp)
      })
    })
  }).catch((err) => {
    reject(err)
  })
}

function QueryPartCost4s (partInfos) {
  return http.post('crm/erp/querypriceinfo', partInfos)
}
